import { render, staticRenderFns } from "./SingleTestDataInfo.vue?vue&type=template&id=27187d1c"
import script from "./SingleTestDataInfo.vue?vue&type=script&lang=js"
export * from "./SingleTestDataInfo.vue?vue&type=script&lang=js"
import style0 from "./SingleTestDataInfo.vue?vue&type=style&index=0&id=27187d1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports